import { getDeepCopy } from "@/utils/utils"

export default {

    isAtLeastOnePrestationSelected: (state, getters) => {
        const selectedPrestations = getters.selectedPrestations
        return selectedPrestations.length > 0
    },
    
    isFewerParticipantsThanTotalMaxCapacity: (state, getters) => { // display oops banner
        const prestations = getters.prestations
        const participants = state.participants

        let totalCapacity = 0
        // let totalPrestations = 0
        // const numOfAdults = participants.filter(participant=>participant===18).length
        prestations.forEach((prest)=>{
            let variants = getDeepCopy(prest.variants)
            const highestMaxCapacityVariant = variants.sort((a,b)=>b.totalMaxCapacity-a.totalMaxCapacity)[0]
            totalCapacity += highestMaxCapacityVariant.totalMaxCapacity
        })

        if (totalCapacity >= participants.length) {
            return true
        }

        return false
    },

    isFewerParticipantsThanSelectedMaxCapacity: (state, getters) => { // display error banner
        const participants = state.participants
        const selectedPrestations = getters.selectedPrestations
        let selectedMaxCapacity = 0
        selectedPrestations.forEach((prestObj) => {
            // If maxCapacity is 0, set it to 1
            const maxCapacity = prestObj.prestation.maxCapacity === 0 ? 1 : prestObj.prestation.maxCapacity;
            selectedMaxCapacity += prestObj.quantity * maxCapacity;
        })
        return participants.length <= selectedMaxCapacity
    },


}